import { render } from "./googleDetails.vue?vue&type=template&id=d25bc08c"
import script from "./googleDetails.vue?vue&type=script&lang=js"
export * from "./googleDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__